export default () => '/gas-list';
